// removed by extract-text-webpack-plugin
module.exports = {"daily_summary":"daily_summary__4fQRV"};


//////////////////
// WEBPACK FOOTER
// ./components/daily-summary/style.scss
// module id = 5dJC
// module chunks = 0 2